const AD_SOURCE_STORAGE_KEY = "ns-roofer-ad-source";
const SUPPORTED_AD_SOURCES = {
  google: "Google Ads",
  facebook: "Facebook Ads",
};

export const detectAdSource = (search = "") => {
  const source = new URLSearchParams(search).get("utm_source");
  return source ? SUPPORTED_AD_SOURCES[source.toLowerCase()] || "" : "";
};

export const getStoredAdSource = () => {
  if (typeof window === "undefined") return "";

  try {
    const adSource = window.sessionStorage.getItem(AD_SOURCE_STORAGE_KEY) || "";
    return Object.values(SUPPORTED_AD_SOURCES).includes(adSource)
      ? adSource
      : "";
  } catch {
    return "";
  }
};

export const persistAdSource = (search = "") => {
  const detectedAdSource = detectAdSource(search);
  if (!detectedAdSource) return getStoredAdSource();
  if (typeof window === "undefined") return detectedAdSource;

  try {
    window.sessionStorage.setItem(AD_SOURCE_STORAGE_KEY, detectedAdSource);
  } catch {
    return detectedAdSource;
  }

  return detectedAdSource;
};
